let audio,
    gameFrame,
    isFullscreen = false,
    gameData = {},
    currentTask = null,
    correctCount = 0,
    totalAttempts = 0,
    tasksCompleted = 0,
    balloons = [],
    animationFrameId = null;

class BalloonGame {
    constructor() {
        this.playArea = document.querySelector('.game__balloon-play');
        this.resultPhase = document.querySelector('[data-phase="result"]');
        this.balloonArea = document.querySelector('[data-balloon-area]');
        this.taskInstruction = document.querySelector('[data-task-instruction]');
        this.correctCountEl = document.querySelector('[data-correct-count]');
        this.remainingCountEl = document.querySelector('[data-remaining-count]');

        // Pobierz dane z window
        if (window.balloonGameData) {
            gameData = window.balloonGameData;
        }

        this.currentClickCount = 0;
        this.targetClickCount = 0;

        this.init();
    }

    init() {
        this.generateBalloons();
        this.startAnimation();
        this.generateNewTask();
    }

    generateBalloons() {
        this.balloonArea.innerHTML = '';
        balloons = [];

        for (let i = 0; i < gameData.balloonCount; i++) {
            const balloon = this.createBalloon();
            balloons.push(balloon);
            this.balloonArea.appendChild(balloon.element);
        }
    }

    createBalloon() {
        const randomColor = gameData.colors[Math.floor(Math.random() * gameData.colors.length)];
        const element = document.createElement('div');
        element.className = 'balloon';
        element.dataset.colorName = randomColor.name;
        element.style.backgroundColor = randomColor.value;

        // Losowa pozycja startowa
        const areaWidth = this.balloonArea.offsetWidth;
        const startX = Math.random() * (areaWidth - 80);
        const startY = this.balloonArea.offsetHeight + 100;

        element.style.left = startX + 'px';
        element.style.bottom = '-100px';

        // Losowa prędkość bazująca na ustawieniach
        let speedMultiplier = 1;
        switch (gameData.speed) {
            case 'slow':
                speedMultiplier = 0.6;
                break;
            case 'medium':
                speedMultiplier = 1;
                break;
            case 'fast':
                speedMultiplier = 1.6;
                break;
        }

        const speed = (1 + Math.random() * 2) * speedMultiplier;
        const drift = (Math.random() - 0.5) * 0.5;

        // Dodaj sznurek
        const string = document.createElement('div');
        string.className = 'balloon-string';
        element.appendChild(string);

        // Event listener
        element.addEventListener('click', (e) => this.handleBalloonClick(e, element, randomColor));

        return {
            element: element,
            x: startX,
            y: startY,
            speed: speed,
            drift: drift,
            color: randomColor,
            popped: false
        };
    }

    handleBalloonClick(e, element, color) {
        e.preventDefault();

        if (element.classList.contains('popped')) {
            return;
        }

        totalAttempts++;

        // Sprawdź czy kliknięty balon jest poprawny
        let isCorrect = false;

        if (currentTask.type === 'color') {
            isCorrect = color.name === currentTask.target;
        } else if (currentTask.type === 'count') {
            this.currentClickCount++;

            // Zawsze pop balonu w trybie liczenia
            this.popBalloon(element);

            if (this.currentClickCount === this.targetClickCount) {
                isCorrect = true;
            } else if (this.currentClickCount > this.targetClickCount) {
                // Za dużo kliknięć
                isCorrect = false;
                this.handleWrongAnswer();
                return;
            } else {
                // Jeszcze nie doszedł do celu, kontynuuj
                this.updateTaskInstruction();
                return;
            }
        }

        if (isCorrect) {
            this.handleCorrectAnswer(element);
        } else {
            this.handleWrongAnswer(element);
        }
    }

    popBalloon(element) {
        element.classList.add('popped');

        // Animacja pękania
        element.style.transform = 'scale(1.3)';
        element.style.opacity = '0';

        setTimeout(() => {
            const index = balloons.findIndex(b => b.element === element);
            if (index > -1) {
                element.remove();
                balloons.splice(index, 1);

                // Dodaj nowy balon
                const newBalloon = this.createBalloon();
                balloons.push(newBalloon);
                this.balloonArea.appendChild(newBalloon.element);
            }
        }, 300);
    }

    handleCorrectAnswer(element) {
        correctCount++;
        tasksCompleted++;

        if (this.correctCountEl) {
            this.correctCountEl.textContent = correctCount;
        }
        if (this.remainingCountEl) {
            this.remainingCountEl.textContent = gameData.tasksCount - tasksCompleted;
        }

        // Pop balonu
        if (element && currentTask.type === 'color') {
            this.popBalloon(element);
        }

        // Dźwięk sukcesu
        if (audio && audio.valid) {
            audio.valid.play();
            stopAudioAfterDelay(audio.valid, 500);
        }

        // Flash zielony
        gameFrame.style.borderColor = 'green';
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
        }, 300);

        // Sprawdź czy gra skończona
        if (tasksCompleted >= gameData.tasksCount) {
            this.endGame();
        } else {
            // Nowe zadanie
            setTimeout(() => {
                this.generateNewTask();
            }, 800);
        }
    }

    handleWrongAnswer(element) {
        // Dźwięk błędu
        if (audio && audio.wrong) {
            audio.wrong.play();
            stopAudioAfterDelay(audio.wrong, 1000);
        }

        // Flash czerwony
        gameFrame.style.borderColor = 'red';
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
        }, 500);

        // Pop balonu w trybie koloru
        if (element && currentTask.type === 'color') {
            this.popBalloon(element);
        }

        // Wyświetl komunikat
        this.showTryAgain();

        // Reset licznika w trybie liczenia
        if (currentTask.type === 'count') {
            this.currentClickCount = 0;
            this.updateTaskInstruction();
        }
    }

    showTryAgain() {
        const tryAgain = document.createElement('div');
        tryAgain.className = 'try-again-message';
        tryAgain.textContent = 'Spróbuj jeszcze raz!';
        this.taskInstruction.appendChild(tryAgain);

        setTimeout(() => {
            tryAgain.remove();
        }, 1500);
    }

    generateNewTask() {
        this.currentClickCount = 0;

        let taskType = gameData.gameMode;
        if (taskType === 'both') {
            taskType = Math.random() < 0.5 ? 'color' : 'count';
        }

        if (taskType === 'color') {
            const randomColor = gameData.colors[Math.floor(Math.random() * gameData.colors.length)];
            currentTask = {
                type: 'color',
                target: randomColor.name,
                color: randomColor.value
            };
            this.updateTaskInstruction();
        } else {
            this.targetClickCount = Math.floor(Math.random() * gameData.maxCount) + 1;
            currentTask = {
                type: 'count',
                target: this.targetClickCount
            };
            this.updateTaskInstruction();
        }
    }

    updateTaskInstruction() {
        if (currentTask.type === 'color') {
            this.taskInstruction.innerHTML = 'Kliknij <span class="task-highlight" style="color: ' + currentTask.color + ';">' + currentTask.target + '</span> balonik';
        } else {
            const remaining = this.targetClickCount - this.currentClickCount;
            if (remaining > 0) {
                this.taskInstruction.innerHTML = 'Kliknij <span class="task-highlight">' + remaining + '</span> ' + this.getPolishPlural(remaining, 'balonik', 'baloniki', 'baloników');
            }
        }
    }

    getPolishPlural(count, singular, plural2to4, plural5plus) {
        if (count === 1) return singular;
        if (count >= 2 && count <= 4) return plural2to4;
        return plural5plus;
    }

    startAnimation() {
        const animate = () => {
            balloons.forEach(balloon => {
                if (!balloon.popped) {
                    balloon.y -= balloon.speed;
                    balloon.x += balloon.drift;

                    balloon.element.style.bottom = balloon.y + 'px';
                    balloon.element.style.left = balloon.x + 'px';

                    // Reset jeśli wyleciał za wysoko
                    if (balloon.y < -150) {
                        balloon.y = this.balloonArea.offsetHeight + 100;
                        balloon.x = Math.random() * (this.balloonArea.offsetWidth - 80);
                    }

                    // Odbicie od krawędzi
                    if (balloon.x < 0 || balloon.x > this.balloonArea.offsetWidth - 80) {
                        balloon.drift *= -1;
                    }
                }
            });

            animationFrameId = requestAnimationFrame(animate);
        };

        animate();
    }

    endGame() {
        // Zatrzymaj animację
        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
        }

        // Ukryj ekran gry
        if (this.playArea) {
            this.playArea.classList.add('hidden');
        }

        // Pokaż ekran wyniku
        if (this.resultPhase) {
            this.resultPhase.classList.remove('hidden');
        }

        // Ustaw statystyki
        const finalCorrect = document.querySelector('[data-final-correct]');
        const finalAttempts = document.querySelector('[data-final-attempts]');
        const finalAccuracy = document.querySelector('[data-final-accuracy]');

        if (finalCorrect) {
            finalCorrect.textContent = correctCount;
        }
        if (finalAttempts) {
            finalAttempts.textContent = totalAttempts;
        }
        if (finalAccuracy) {
            const accuracy = totalAttempts > 0 ? Math.round((correctCount / totalAttempts) * 100) : 0;
            finalAccuracy.textContent = accuracy + '%';
        }

        // Dźwięk zakończenia
        if (audio && audio.success) {
            audio.success.play();
            stopAudioAfterDelay(audio.success, 3000);
        }
    }

    restart() {
        // Reset zmiennych
        correctCount = 0;
        totalAttempts = 0;
        tasksCompleted = 0;
        this.currentClickCount = 0;

        if (this.correctCountEl) {
            this.correctCountEl.textContent = '0';
        }
        if (this.remainingCountEl) {
            this.remainingCountEl.textContent = gameData.tasksCount;
        }

        // Zatrzymaj starą animację
        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
        }

        // Pokaż ekran gry
        if (this.playArea) {
            this.playArea.classList.remove('hidden');
        }
        if (this.resultPhase) {
            this.resultPhase.classList.add('hidden');
        }

        // Reset ramki
        gameFrame.style.borderColor = 'black';

        // Rozpocznij od nowa
        this.generateBalloons();
        this.startAnimation();
        this.generateNewTask();
    }
}

// Helper function
function stopAudioAfterDelay(audioElement, delay) {
    setTimeout(() => {
        if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
        }
    }, delay);
}

// Initialize game function
function initGame() {
    gameFrame = document.querySelector('.game__frame--balloon');

    if (!gameFrame) {
        return;
    }

    // Initialize audio
    audio = {
        start: document.getElementById('sound-start'),
        valid: document.getElementById('sound-valid'),
        wrong: document.getElementById('sound-wrong'),
        success: document.getElementById('sound-success'),
        drag: document.getElementById('sound-drag')
    };

    // Initialize game
    const game = new BalloonGame();

    // Fullscreen toggle
    const fullscreenButton = document.querySelector('[data-toggle-fullscreen]');
    if (fullscreenButton) {
        fullscreenButton.addEventListener('click', () => {
            if (!isFullscreen) {
                if (gameFrame.requestFullscreen) {
                    gameFrame.requestFullscreen();
                } else if (gameFrame.webkitRequestFullscreen) {
                    gameFrame.webkitRequestFullscreen();
                } else if (gameFrame.msRequestFullscreen) {
                    gameFrame.msRequestFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-expand');
                fullscreenButton.querySelector('i').classList.add('fa-compress');
                isFullscreen = true;
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-compress');
                fullscreenButton.querySelector('i').classList.add('fa-expand');
                isFullscreen = false;
            }
        });
    }

    // Restart buttons
    const restartButtons = document.querySelectorAll('[data-game-restart]');
    restartButtons.forEach(button => {
        button.addEventListener('click', () => {
            game.restart();
        });
    });

    // Back button
    const backButton = document.querySelector('[data-backward]');
    if (backButton) {
        backButton.addEventListener('click', () => {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
            window.history.back();
        });
    }
}

export default { initGame };




// WEBPACK FOOTER //
// ./src/scripts/game-balloon.js